import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { isMultiDomains } from 'utils/isMultiDomain';
import { hasPrivilege, PLAYLIST_WRITE } from 'utils/privileges';
import InlineList from 'components/InlineList';
import PlaylistDropdown from 'components/ParentPlaylistDropdown';
import TextPlaceholder from 'components/TextPlaceholder';
import Box from 'components/Box';
import { ExternalDomainLink, getDistributedInfo } from 'screens/SinglePlaylistManager';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function AssetHeaderSubtitle(_ref) {
  var asset = _ref.asset;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isPlaylistAdmin = hasPrivilege(PLAYLIST_WRITE);
  if (!asset) {
    return /*#__PURE__*/_jsx(Box, {
      fontSize: "s",
      children: /*#__PURE__*/_jsx(TextPlaceholder, {
        width: 140
      })
    });
  }
  var id = asset.id,
    originatingId = asset.originatingId,
    domain_id = asset.domain_id,
    _asset$parentPlaylist = asset.parentPlaylists,
    parentPlaylists = _asset$parentPlaylist === void 0 ? [] : _asset$parentPlaylist,
    sourceDomain = asset.sourceDomain;
  var isDistributed = isMultiDomains([domain_id]);
  var parentPlaylistCount = parentPlaylists.length;
  var _getDistributedInfo = getDistributedInfo({
      sourceDomain: sourceDomain,
      id: id,
      originatingId: originatingId,
      contentType: 'asset'
    }),
    sourceUrl = _getDistributedInfo.sourceUrl,
    hubName = _getDistributedInfo.hubName;
  return /*#__PURE__*/_jsx(Box, {
    dimmed: true,
    fontSize: "s",
    children: /*#__PURE__*/_jsxs(InlineList, {
      splitBy: "dot",
      children: [parentPlaylistCount && /*#__PURE__*/_jsxs(Trans, {
        t: t,
        i18nKey: 'hint_used_in_playlist',
        count: parentPlaylistCount,
        children: ['Used in', ' ', /*#__PURE__*/_jsx(PlaylistDropdown, {
          playlists: parentPlaylists,
          children: "count playlists"
        })]
      }), isPlaylistAdmin && isDistributed && hubName && /*#__PURE__*/_jsxs(Trans, {
        t: t,
        i18nKey: "hint_distributed_from_hub_name",
        values: {
          hubName: hubName
        },
        children: ['Distributed from', ' ', /*#__PURE__*/_jsx(ExternalDomainLink, {
          href: sourceUrl,
          children: "hubName"
        })]
      })]
    })
  });
}
export default AssetHeaderSubtitle;